export default {
  back: 'Torna al menu',
  menu: 'Menu',
};
